import request from '@/router/axios';

export const add = (data) => {
  return request({
    url: '/api/produce/emergency-support-personnel/insert',
    method: 'post',
    data,
  });
};

export const update = (data) => {
  return request({
    url: '/api/produce/emergency-support-personnel/update',
    method: 'post',
    data,
  });
};

export const getDetail = (id) => {
  return request({
    url: '/api/produce/emergency-support-personnel/select/id',
    method: 'get',
    params: { id },
  });
};

export const getList = (data) => {
  return request({
    url: '/api/produce/emergency-support-personnel/select/page',
    method: 'post',
    data,
  });
};

export const remove = (id) => {
  return request({
    url: '/api/produce/emergency-support-personnel/delete/id',
    method: 'get',
    params: { id },
  });
};

export const removeBatch = (ids) => {
  return request({
    url: '/api/produce/emergency-support-personnel/delete/ids',
    method: 'get',
    params: { ids },
  });
};
